import { Grid2 } from '@mui/material'
import { KeyboardEvent, MouseEvent, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { MapSection } from '../../components/MapSection'
import { UtilitySlideout } from '../../components/UtilitySlideout'
import { UtilityDetail } from '../../components/UtilitySlideout/subComponents'
import { AppActions } from '../../store/app'
import { MapRefProps } from './Main'
import { OverlayDesktop } from './Overlay.desktop'

export const MainDesktop = () => {
  const dispatch = useDispatch()
  const mapRef = useRef<MapRefProps | null>(null)
  const mapContainerRef = useRef<HTMLDivElement | null>(null)
  const flyoutContainerRef = useRef<HTMLDivElement | null>(null)
  const debounceResize = useRef(null as any)
  const onCloseUtilityDetail = (e: MouseEvent | KeyboardEvent) => {
    dispatch(AppActions.setMapDataDrawerOpen(false))
  }

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      clearTimeout(debounceResize.current)
      const resizeEvent = new CustomEvent('mapContainerResize', { detail: entries[0].contentRect })
      debounceResize.current = setTimeout(()=>{
        window.dispatchEvent(resizeEvent)
      },150)

    })
    if (mapContainerRef.current) {
      observer.observe(mapContainerRef.current)
    }
    const mcRef = mapContainerRef.current
    return () => {
      clearTimeout(debounceResize.current)
      if (mcRef) {
        observer.unobserve(mcRef)
      }
    }
  }, [])



  return (
    <>
      <Grid2
        container
        flexDirection="row"
        ref={mapContainerRef}
        sx={{ flexGrow: 1, position: 'relative' }}
      >
        <OverlayDesktop mapRefs={mapRef} />
        <MapSection ref={mapRef} />
      </Grid2>
      <Grid2
        container
        flexDirection="row"
        flexGrow={0}
        flexShrink={1}
        ref={flyoutContainerRef}
        sx={{
          flexShrink: 1,
          //overflowY: 'auto',
          position: 'relative',
          //flexBasis:  'auto',
          maxWidth: '30%',
          //width: utilityOpen || utilityDetailOpen  ? '30%' : '0%',

          transition: 'all 0.5s ease',
        }}
      >
        <UtilityDetail onClose={onCloseUtilityDetail} mapRef={mapRef} />
        <UtilitySlideout
          mapRef={mapRef}
        />

      </Grid2>
    </>
  )
}
